import { z } from 'zod';

// Response shape for a managed policy document. storage_key is intentionally
// NOT exposed — the file is reached via the download endpoint, never a raw key.
export const PolicyDocument = z.object({
  id: z.string().uuid(),
  original_filename: z.string(),
  content_type: z.string(),
  size_bytes: z.number().int().nonnegative(),
  sort_order: z.number().int(),
  active: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});
export type PolicyDocument = z.infer<typeof PolicyDocument>;

export const PolicyDocumentList = z.array(PolicyDocument);

export const PolicyDocumentUpdateInput = z
  .object({
    active: z.boolean().optional(),
    sort_order: z.number().int().optional(),
  })
  .refine((o) => Object.keys(o).length > 0, { message: 'At least one field must be provided' });
export type PolicyDocumentUpdateInput = z.infer<typeof PolicyDocumentUpdateInput>;

export const PolicyDocumentReorderInput = z.object({
  ids: z.array(z.string().uuid()).min(1),
});
export type PolicyDocumentReorderInput = z.infer<typeof PolicyDocumentReorderInput>;
